import { Power2, gsap } from 'gsap';

import { gsapTimelineFunc } from '../gsap-config';

export const lightSpeedIn: gsapTimelineFunc = (target) => {
  return gsap
    .timeline({ defaults: { ease: Power2.easeInOut } })
    .fromTo(
      target,
      {
        duration: 0,
        skewX: 0,
        opacity: 0,
        x: '150%',
      },
      {
        duration: 0.1,
        skewX: -90,
        opacity: 0,
        x: '150%',
      }
    )
    .to(target, {
      duration: 0.2,
      skewX: -10,
      opacity: 1,
      x: '10%',
    })
    .to(target, { duration: 0.2, skewX: 10, x: '-10%' })
    .to(target, { duration: 0.1, skewX: -5, x: '5%' })
    .to(target, { duration: 0.1, skewX: 0, x: '0%' })
    .to(target, { duration: 0.1, skewX: 0, x: '0%' })
    .to(target, { duration: 0.2, skewX: 0, x: '0%' });
};
